/** 공유 보드 저장 이름(접두) + 화면 표시용 접미 */
export const TODO_SHARE_TITLE_SUFFIX = ' TODO 노트';

/** 개인 노트에서 이전된 고정 기본 보드 이름 */
export const TODO_SHARE_DEFAULT_BOARD_NAME = '기본';

/** 저장된 title에서 표시용 이름만 추출 (접미 제거) */
export function todoShareNameFromTitle(title: string): string {
  return title.trim().replace(/\s*(TODO|ToDo)\s*노트\s*$/i, '').trim();
}

/** 페이지 타이틀: `바나나` → `바나나 TODO 노트` */
export function formatTodoSharePageTitle(title: string): string {
  const name = todoShareNameFromTitle(title);
  return name ? `${name}${TODO_SHARE_TITLE_SUFFIX}` : `공유${TODO_SHARE_TITLE_SUFFIX}`;
}

export function isTodoShareDefaultBoard(board: {
  source_kind?: string | null;
  title?: string | null;
}): boolean {
  if (board.source_kind === 'personal_default') return true;
  return todoShareNameFromTitle(board.title ?? '') === TODO_SHARE_DEFAULT_BOARD_NAME;
}

/** 기본 보드를 항상 맨 앞, 나머지는 created_at 오름차순 */
export function sortTodoShareBoards<T extends {
  source_kind?: string | null;
  title?: string | null;
  created_at?: string;
  id: string;
}>(boards: T[]): T[] {
  return [...boards].sort((a, b) => {
    const aDef = isTodoShareDefaultBoard(a) ? 0 : 1;
    const bDef = isTodoShareDefaultBoard(b) ? 0 : 1;
    if (aDef !== bDef) return aDef - bDef;
    const at = a.created_at ?? '';
    const bt = b.created_at ?? '';
    if (at !== bt) return at.localeCompare(bt);
    return a.id.localeCompare(b.id);
  });
}
